import { useEffect, useState } from "react";

// Signature brand element: the "i" in PeopleiKnow gets a new random color on every load.
const I_COLORS = [
  "#ec4899",
  "#f59e0b",
  "#10b981",
  "#8b5cf6",
  "#06b6d4",
  "#1d4ed8",
  "#ef4444",
];

const randomI = () => I_COLORS[Math.floor(Math.random() * I_COLORS.length)];

// Exact aspect ratios of the traced wordmark art (from the app's own logo).
const WM_RATIO = { people: 320 / 129, i: 34 / 129, know: 241 / 129 };

export const Logo = ({ size = "md", className = "", showIcon = true }) => {
  const [iColor, setIColor] = useState("#1d4ed8");

  useEffect(() => {
    setIColor(randomI());
  }, []);

  const wordmarkHeight =
    size === "lg" ? "h-12 sm:h-[54px]" : size === "sm" ? "h-[30px]" : "h-9";
  const iconHeight =
    size === "lg" ? "h-10 sm:h-[45px]" : size === "sm" ? "h-[25px]" : "h-[30px]";

  return (
    <span
      className={`inline-flex items-end gap-2 ${className}`}
      data-testid="brand-logo"
    >
      {showIcon && (
        <img
          src="/app-logo.png"
          alt="peopleiknow logo"
          className={`${iconHeight} w-auto shrink-0`}
        />
      )}
      <span
        className={`inline-flex items-center ${wordmarkHeight}`}
        role="img"
        aria-label="peopleiknow"
        data-testid="brand-logo-wordmark"
      >
        <img
          src="/wordmark-people.png"
          alt=""
          aria-hidden="true"
          className="h-full w-auto shrink-0"
          style={{ aspectRatio: WM_RATIO.people }}
        />
        <span
          aria-hidden="true"
          className="h-full shrink-0"
          data-testid="brand-logo-i"
          style={{
            aspectRatio: WM_RATIO.i,
            backgroundColor: iColor,
            WebkitMaskImage: "url(/wordmark-i-mask.png)",
            maskImage: "url(/wordmark-i-mask.png)",
            WebkitMaskSize: "contain",
            maskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            maskPosition: "center",
          }}
        />
        <img
          src="/wordmark-know.png"
          alt=""
          aria-hidden="true"
          className="h-full w-auto shrink-0"
          style={{ aspectRatio: WM_RATIO.know }}
        />
      </span>
    </span>
  );
};

// Inline brand name for use within copy. Each instance gets its own random "i" color.
// Pass `dark` on dark/colored backgrounds so the "i" stays high-contrast (no blue).
const BRIGHT_I_COLORS = [
  "#f472b6",
  "#fbbf24",
  "#34d399",
  "#a78bfa",
  "#22d3ee",
  "#f87171",
];

export const Brand = ({ withAi = false, className = "", dark = false }) => {
  const palette = dark ? BRIGHT_I_COLORS : I_COLORS;
  const [iColor, setIColor] = useState(dark ? "#fbbf24" : "#1d4ed8");

  useEffect(() => {
    setIColor(palette[Math.floor(Math.random() * palette.length)]);
  }, [dark]);

  return (
    <span className={`font-semibold ${className}`}>
      People
      <span style={{ color: iColor }}>i</span>
      Know
      {withAi && ".ai"}
    </span>
  );
};

export default Logo;
